import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export async function getRegionalManagers() {
  const data = await axios({
    url: API_URL,
    method: "post",
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      query: `
              query {
                getUsers(isRegionalManager: true) {
                  id
                  firstName
                  lastName
                  email
                  isRegionalManager
                }
              }
              `,
      variables: {},
    },
  });
  return data?.data?.data?.getUsers;
}
